import { useNavigate } from 'react-router-dom';
import { Home, TrendingUp, MessageCircle, Users, Music, BarChart3, BookOpen, Mic } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

export default function Navigation({ active }) {
  const navigate = useNavigate();
  const { t } = useLanguage();

  const navItems = [
    { id: 'dashboard', icon: Home, label: t('home'), path: '/dashboard' },
    { id: 'journal', icon: BookOpen, label: t('journal'), path: '/journal' },
    { id: 'voice-chat', icon: Mic, label: t('voice'), path: '/voice-chat' },
    { id: 'history', icon: BarChart3, label: t('history'), path: '/history' },
    { id: 'community', icon: Users, label: t('community'), path: '/community' }
  ];

  return (
    <nav 
      className="fixed bottom-0 left-0 right-0 bg-white/95 backdrop-blur-sm border-t border-stone-200 px-2 py-2"
      data-testid="navigation-bar"
    >
      <div className="container mx-auto max-w-4xl">
        <div className="flex justify-around items-center">
          {navItems.map((item) => {
            const Icon = item.icon;
            const isActive = active === item.id;
            return (
              <button
                key={item.id}
                data-testid={`nav-${item.id}`}
                onClick={() => navigate(item.path)}
                className={`flex flex-col items-center gap-0.5 px-2 py-1.5 rounded-lg transition-all duration-300 ${
                  isActive ? 'bg-hunter-green/10' : 'hover:bg-stone-50'
                }`}
              >
                <Icon 
                  className={`w-5 h-5 ${isActive ? 'text-hunter-green' : 'text-warm-charcoal/40'}`}
                  strokeWidth={isActive ? 2 : 1.5}
                />
                <span className={`text-[10px] font-medium ${isActive ? 'text-hunter-green' : 'text-warm-charcoal/40'}`}>
                  {item.label}
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </nav>
  );
}